import React from "react";
import Div from "@jumbo/shared/Div";
import CodeEditorAndOutputPanel from "components/CodeEditorAndOutput/CodeEditorAndOutputPanel";

const EditorPanel = ({
  code,
  setCode,
  editorLanguage,
  headerControls,
  codeTabs,
  outputTabs,
  outputContent,
  theme,
  codeTabValue,
  setCodeTabValue,
  ioTabValue,
  setOutputTabValue,
  handleIOTabChange,
}) => {
  return (
    <Div sx={{ display: "flex", height: "100%", overflowY: "auto" }}>
      <CodeEditorAndOutputPanel
        code={code}
        setCode={setCode}
        editorLanguage={editorLanguage}
        headerControls={headerControls}
        codeTabs={codeTabs}
        outputTabs={outputTabs}
        outputContent={outputContent}
        theme={theme}
        codeTabValue={codeTabValue}
        setCodeTabValue={setCodeTabValue}
        ioTabValue={ioTabValue}
        setOutputTabValue={setOutputTabValue}
        handleIOTabChange={handleIOTabChange}
      />
    </Div>
  );
};

export default EditorPanel;
